// Ukuran kertas dokumen.
//
// "½ A4" di toko = selembar A4 yang DIPOTONG MELINTANG → 210 mm lebar × 148 mm tinggi (melebar),
// bukan A5 tegak. Ini pernah salah dipasang dan membuat semua dokumen tercetak dengan orientasi
// keliru; angka di bawah adalah sumber kebenarannya, jangan ditulis ulang di tempat lain.
export type UkuranKertas = 'A5' | 'A4';

/** Piksel per milimeter pada 96 dpi — dipakai menaksir jumlah lembar sebelum mencetak. */
export const PX_PER_MM = 96 / 25.4;

// Margin cetak (mm). Kiri-kanan dibuat lega karena kertas ½ A4 dipotong sendiri dari A4 —
// potongannya bisa miring dan printer meleset saat menarik kertas. Anggaran terburuknya:
// area tak-tercetak printer laser ±4,2 mm + registrasi tarikan ±2 mm + skew potong ±1,4 mm
// ≈ 7,6 mm; 12 mm memberi cadangan ±4 mm. Jangan lebih dari 12 — tinggi ½ A4 hanya 148 mm
// dan nota sudah memakai 122,5 dari 129 mm yang tersedia.
//
// PENTING: bantalan samping TIDAK ditaruh di `@page`. Dialog cetak browser punya pilihan
// "Margins: None" yang menimpa `@page`; bila bantalannya di situ, isi bisa mepet tepi persis
// seperti yang hendak dicegah. Karena itu `@page` samping = 0 dan 12 mm-nya dipasang sebagai
// padding isi saat mencetak (lihat `documents.view.ts`) — padding tak bisa ditimpa operator.
export const MARGIN_SAMPING_MM = 12;
export const MARGIN_ATAS_MM = 8;
export const MARGIN_BAWAH_MM = 11;

export interface Kertas {
  wmm: number;
  hmm: number;
  /** Nilai untuk `@page { size: … }`. */
  css: string;
  /** Nilai untuk `@page { margin: … }` (atas · kiri-kanan · bawah). */
  marginCss: string;
  /** Lebar area isi = lebar kertas − margin kiri-kanan. */
  isiMm: number;
  /** Bantalan kiri-kanan yang berlaku (mm). */
  sampingMm: number;
  /** TINGGI area isi = tinggi kertas − margin atas-bawah. Inilah batas satu lembar; memakai
   *  tinggi kertas penuh membuat dokumen dinyatakan "muat" padahal tercetak jadi dua. */
  isiTinggiMm: number;
  /** Nama yang dibaca petugas. */
  label: string;
}

export function pageDims(size: UkuranKertas, marginSamping?: number): Kertas {
  const a4 = size === 'A4';
  const wmm = 210, hmm = a4 ? 297 : 148;
  // Bantalan samping bisa disetel per dokumen; dijepit 5–30 mm supaya salah ketik tak
  // membuat isi mepet tepi (di bawah 5 mm printer laser memotong) atau dokumen jadi kurus.
  const sp = Number.isFinite(marginSamping) ? Math.min(30, Math.max(5, Number(marginSamping))) : MARGIN_SAMPING_MM;
  return {
    wmm, hmm,
    css: a4 ? 'A4' : 'A5 landscape',
    marginCss: `${MARGIN_ATAS_MM}mm 0 ${MARGIN_BAWAH_MM}mm`,
    isiMm: wmm - sp * 2,
    sampingMm: sp,
    isiTinggiMm: hmm - MARGIN_ATAS_MM - MARGIN_BAWAH_MM,
    label: a4 ? 'A4 penuh' : '½ A4 melebar (210 × 148 mm)',
  };
}
